import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FieldBlock from "../../../PreActivation/components/FieldBlock";
import FieldError from "../../../PreActivation/components/FieldError";
import FieldHint from "../../../PreActivation/components/FieldHint";
import FieldLabel from "../../../PreActivation/components/FieldLabel";
import RadioGroup from "../../../PreActivation/components/RadioGroup";

const RadioFieldBlock = ({
  name,
  labelKey,
  hintKey,
  required = false,
  options,
  control,
  readOnly,
}) => {
  const { t } = useTranslation();

  return (
    <FieldBlock>
      <FieldLabel htmlFor={name} text={t(labelKey)} required={required} />
      {hintKey ? <FieldHint text={t(hintKey)} /> : null}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <RadioGroup
              name={name}
              options={options}
              selectedValue={field.value}
              onChange={field.onChange}
              readOnly={readOnly}
            />
            <FieldError message={fieldState.error?.message} />
          </>
        )}
      />
    </FieldBlock>
  );
};

export default RadioFieldBlock;
